import { inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { SessionService } from "src/app/services/session.service";

@Injectable()
export class LockIfSessionIsDeadGuard implements CanActivate {
  readonly #bootstrapService = inject(BootstrapService);
  readonly #sessionService = inject(SessionService);

  async canActivate(): Promise<boolean> {
    if (!this.#bootstrapService.getCurrentUser()?.dynamicLockEnabled) {
      return true;
    }

    if (!this.#sessionService.isActive()) {
      await this.#sessionService.lock();
      return false;
    }

    return true;
  }
}
